import { t } from 'i18next';
import { getGroupName } from '../../components/grid/groups/HeaderGroups';
import { ReturnTypeofSheetSectionsSelector } from '../../selectors/sheetUiSelector';
import { GridEntity, IRange } from '../../types';
import { HeaderGroup } from '../../types/sheet/headerGroups';
import { isRangeInsideRanges } from '../../utils/area/range';
import { BiHide, BiShow } from 'react-icons/bi';
import { IoMdRemove } from 'react-icons/io';
import { MdSettingsInputComposite } from 'react-icons/md';
import { VscGroupByRefType } from 'react-icons/vsc';
import { IContextMenuItem } from './types';
import { UseGridOperations } from '../../hooks/useGridOperations';
import { SheetCommandType } from '../../types/commands/sheetCommands/sheetCommands';

// export {};

const getGroupLangKeys = (isHidden: boolean, nestedGroups: boolean) => [
  isHidden ? 'expand_group' : 'collapse_group',
  'remove_group',
  'advance_settings',
  nestedGroups ? 'nested_groups' : undefined,
];

export const getGroupMenu = (
  group: HeaderGroup,
  entityType: GridEntity,
  parentLangKey: string,
  props: ReturnTypeofSheetSectionsSelector,
  // performGridOperation: UseGridOperations['performGridOperation']
) => {
  const isColumn = entityType === GridEntity.Column;
  const groupRange = {
    start: group.start,
    end: group.end,
  };

  const hiddenRanges = isColumn ? props.hiddenCols : props.hiddenRows;
  const isHidden = isRangeInsideRanges(groupRange, hiddenRanges);

  const groupName = getGroupName(group, isColumn);

  const langParams = {
    name: groupName,
  };

  const menus: IContextMenuItem[] = [];
  getGroupLangKeys(isHidden, !!group.nestedGroups?.length).forEach(
    (langKey) => {
      if (langKey) {
        const title = t(`${parentLangKey}.${langKey}`, langParams);
        const Icon = getGroupMenuIcon(langKey);
        let nestedMenus: IContextMenuItem[][] | undefined;

        if (langKey === 'nested_groups') {
          nestedMenus = createNestedGroupMenu(
            group.nestedGroups,
            entityType,
            props,
            // performGridOperation
          );
        }
        menus.push({
          title,
          Icon,
          nestedMenus,
          action: getGroupAction(
            group.id,
            groupRange,
            entityType,
            langKey,
            isHidden,
            // performGridOperation
          ),
        });
      }
    }
  );

  return menus;
};

const createNestedGroupMenu = (
  groups: HeaderGroup[],
  entityType: GridEntity,
  props: ReturnTypeofSheetSectionsSelector,
  // performGridOperation: UseGridOperations['performGridOperation']
) => {
  const menus: IContextMenuItem[] = [];
  const isColumn = entityType === GridEntity.Column;
  groups.forEach((group) => {
    const range = {
      start: group.start,
      end: group.end,
    };

    const hiddenRanges = isColumn ? props.hiddenCols : props.hiddenRows;

    const isHidden = isRangeInsideRanges(range, hiddenRanges);

    menus.push({
      title: getGroupName(group, isColumn),
      checkbox: true,
      checked: !isHidden,
      action: () => {},
        // performGridOperation(entityType, {
        //   op: isHidden
        //     ? SheetCommandType.UnhideGrid
        //     : SheetCommandType.HideGrid,
        //   ranges: [range],
        // }),
      nestedMenus: group.nestedGroups?.length
        ? createNestedGroupMenu(
            group.nestedGroups,
            entityType,
            props,
            // performGridOperation
          )
        : undefined,
    });
  });

  return [menus];
};

const getGroupMenuIcon = (langKey: string) => {
  switch (langKey) {
    case 'expand_group':
      return BiShow;
    case 'collapse_group':
      return BiHide;
    case 'remove_group':
      return IoMdRemove;
    case 'advance_settings':
      return MdSettingsInputComposite;
    case 'nested_groups':
      return VscGroupByRefType;
  }
};

const getGroupAction = (
  groupId: string,
  groupRange: IRange,
  entityType: GridEntity,
  langKey: string,
  isHidden: boolean,
  // performGridOperation: UseGridOperations['performGridOperation']
) => {
  switch (langKey) {
    case 'expand_group':
    case 'collapse_group':
      return () => {}
        // performGridOperation(entityType, {
        //   op: isHidden ? SheetCommandType.UnhideGrid : SheetCommandType.HideGrid,
        //   ranges: [groupRange],
        // });
    case 'remove_group':
      return () => {}
        // performGridOperation(entityType, {
        //   op: SheetCommandType.UngroupGrid,
        //   groupId: groupId,
        // });
  }

  return undefined;
};
